function girlFightView(girl_id,boxJQ,data){
    this.main=boxJQ;
    this.type_arr=["attack","critical","speed"];
//    data={"stat_base":{"attack":"1507","critical":"100","speed":1507},"obj_old":{"stat":{"attack":1552,"critical":109,"speed":108},"bonus":{"attack":[{"type":"own","val":3}],"critical":[{"type":"own","val":9}],"speed":[{"type":"own","val":8}]}},"obj_cur":{"stat":{"attack":1552,"critical":109,"speed":1628},"bonus":{"attack":[{"type":"own","val":3}],"critical":[{"type":"own","val":9}],"speed":[{"type":"own","val":8}]}}};
    this.bonus_cur=copyObj(data.obj_cur.bonus);
    this.bonus_old=copyObj(data.obj_old.bonus);
    this.stat_cur=copyObj(data.obj_cur.stat);
    this.stat_old=copyObj(data.obj_old.stat);
//    console.log(data);
}
girlFightView.prototype={
    start:function(){
        this.allBelts();
        this.allVal();
       
    },
    update:function(data){
        this.bonus_old=copyObj(this.bonus_cur);
        this.stat_old=copyObj(this.stat_cur);
        this.bonus_cur=copyObj(data.obj_cur.bonus);
        this.stat_cur=copyObj(data.obj_cur.stat);
        this.start();
    },
    allVal:function(){
        var val_str,type,rowObj;
        for(type in this.stat_cur){
            rowObj=this.main.find(".row[data-type='"+type+"'] .valWrap");
            if(this.stat_cur[type]!=this.stat_old[type]){
                val_str=this.stat_cur[type]-this.stat_old[type];
                if(val_str>0){
                    val_str="+"+numberFormat(val_str);
                }
                else{
                    val_str=numberFormat(val_str);
                }
                rowObj.find(".blink").disappear(val_str);
            }
            rowObj.find(".val").html(numberFormat(this.stat_cur[type]));
        }
    },
    allBelts:function(){
//        console.log(this.bonus_old);
        var type,bum,i,sum_cur=0,sum_old=0,res,res_belt={};
        for(i in this.type_arr){
            type=this.type_arr[i];
            res=this.countBelt(this.bonus_old[type],this.bonus_cur[type]);
            sum_cur=Math.max(sum_cur,res.sum_cur);
            sum_old=Math.max(sum_old,res.sum_old);
            res_belt[type]=copyObj(res.belts);
        }
        var k,bum,html="",wrapBeltObj,wrapBeltObjExt,width_old,width_cur;
        for(i in res_belt){
            html=""
            for(type in res_belt[i]){
                bum=res_belt[i][type];
                html+="<div class='ext' data-type='"+type+"'></div>";
            }
//            class="cell" data-type="attack"
            wrapBeltObj=this.main.find(".row[data-type='"+i+"'] .belt .extWrap");
            wrapBeltObj.html(html);
            for(type in res_belt[i]){
                bum=res_belt[i][type];
                width_old=bum.old/sum_old*100;
                width_cur=bum.cur/sum_cur*100;
                wrapBeltObjExt=wrapBeltObj.find(".ext[data-type='"+type+"']");
                wrapBeltObjExt.width(width_old+"%");//.animate("width",width_cur+"%",1000);
                if(bum.old*sum_cur!=bum.cur*sum_old){
                    wrapBeltObjExt.animate({"width":width_cur+"%"},1000,function(){
                        if($(this).width()==0){
                            $(this).remove();
                        }
                    });
                }
                
            }
        }
        
    },
    countBelt:function(row_old,row_new){
        var res={},i,bum,sum_old=0,sum_cur=0;
        for(i in row_old){
            bum=row_old[i];
            if(typeof res[bum.type]=="undefined"){
                res[bum.type]={"old":bum.val,"cur":0};
            }
            else{
                res[bum.type].old+=bum.val;
            }
            
            sum_old+=bum.val;
        }
        for(i in row_new){
            bum=row_new[i];
            if(typeof res[bum.type]=="undefined"){
                res[bum.type]={"old":0,"cur":bum.val};
            }
            else{
                res[bum.type].cur+=bum.val;
            }
            sum_cur+=bum.val;
        }
        return {sum_cur:sum_cur,sum_old:sum_old,belts:res};
    },
    
};